<template>
  <div class="ub ub-ac ub-pc service-expiration">
    <img class="img ub" src="../../assets/images/service-expiration.png" />
    <div class="text ub">服务到期</div>
  </div>
</template>
<script lang="ts">
import { defineComponent, onMounted, reactive } from "vue";
export default defineComponent({
  isGlobal: true,
  name: "ServiceExpiration",
});
</script>
<style lang="less" scoped>
.img {
  width: 10px;
  height: 10px;
}
.service-expiration {
  height: 18px;
  background: linear-gradient(90deg, #e5e8f7 0%, #c2c8da 100%);
  border-radius: 11px;
  position: absolute;
  top: 4px;
  right: 4px;
  padding: 0 5px;
  box-sizing: border-box;
}
.text {
  height: 10px;
  font-size: 10px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #424c5d;
  line-height: 10px;
  margin-left: 3px;
}
</style>
